import { postAction } from '@/apis/request'

export function getCarDetail(params) {
  return postAction('/cms/goods/pageGoodsParts', params)
}

// 获取商品汽配筛选信息
export function getCarDetailFilter(params) {
  return postAction('/cms/goods/partsFilter', params)
}
